'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _page = require('./remote/page');

exports.default = {
    fetchAboutData: _page.PageRemote.fetchAboutData,
    fetchHomeData: _page.PageRemote.fetchHomeData
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/page.js
// module id = 96CX
// module chunks = 60